import { uniqWith } from 'lodash';

export function removeDuplicates<T>(duplicatedItems: T[], callbackComparator: (itemFirst: T, itemSecond: T) => boolean): T[] {
  return uniqWith(duplicatedItems, callbackComparator);
}
